import { AccountType } from "../../types/account";
import { SessionStore } from "../../types/store";

export const useAccountPermissions = () => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}"
  );

  const isEntityUser =
    session?.accountType === AccountType.ENTITY;

  const isEntityWriteUser =
    session?.accountType === AccountType.ENTITY_WRITE;

  const isEntityAccount =
    isEntityUser || isEntityWriteUser;

  const canEditData =
    !isEntityUser;

  const canViewEntityList =
    !isEntityAccount;

  return {
    isEntityUser,
    isEntityWriteUser,
    isEntityAccount,
    canEditData,
    canViewEntityList,
  };
};
